import Select, { SelectProps } from "@/shared/form/select";

import { DynamicAttributeEntity } from "gql/graphql";

import { useTranslations } from "use-intl";

type DynamicAttributeEntityKey = keyof typeof DynamicAttributeEntity;

export function EntitySelectView(props: SelectProps) {
  const t = useTranslations("EntitySelectView");

  return (
    <Select
      allowClear
      placeholder={t("Select entity")}
      className="w-full"
      options={Object.keys(DynamicAttributeEntity).map((key) => {
        const value = DynamicAttributeEntity[key as DynamicAttributeEntityKey];

        return {
          label: t(value),
          value,
        };
      })}
      {...props}
    />
  );
}
